import {extendObservable, toJS} from 'mobx'
import firebase from '../firebase'
//TODO: import Logger from './Logger'

class MessageStore {
    constructor(authStore, notificationStore) {
        extendObservable(this, {
            messages: {},
        })
        this.authStore = authStore
        this.notificationStore = notificationStore
    }
    loadMessagesForIdea(ideaKey){
        firebase.database().ref().child('messages/'+ideaKey).on('value', snap => {
            this.messages = snap.val()
        })
    }
    unloadMessages(ideaKey){
        this.messages = {}
        firebase.database().ref().child('messages/'+ideaKey).off()
    }
    newMessage(message, ideaKey, theIdea){
        const authUser = this.authStore.authUser()
        const msgRef = firebase.database().ref().child('messages/')
        const ideaRef = firebase.database().ref().child('ideas/'+ideaKey)
        const updatedRef = ideaRef.child('lastUpdated')

        var msg = {
            fromName: authUser.displayName,
            fromPhotoURL: authUser.photoURL,
            text:message,
            timestamp:firebase.database.ServerValue.TIMESTAMP,
        }
        msgRef.child(ideaKey).push(msg)
        updatedRef.set(firebase.database.ServerValue.TIMESTAMP)
        this.notificationStore.createNotificationToTeamMembers(ideaKey, authUser.displayName + ' wrote: ' + message, theIdea.owner, toJS(theIdea.team), theIdea.responsible)
    }
}

export default MessageStore


// WEBPACK FOOTER //
// ./src/stores/MessageStore.js